import * as cryptoJs from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class Encrypt {
  public encryptMd5(password: string): string {
    return String(cryptoJs.MD5(password));
  }
}
